import { useTranslation } from "react-i18next";
import { Badge } from "@nexus/ui";
import type { ChangelogEntryState } from "@/features/changelog/lib/changelog-display";

const STATE_BADGE_VARIANT: Record<
  ChangelogEntryState,
  "status-delivered" | "status-in-production" | "status-error" | "status-sent" | "slate"
> = {
  sent: "status-delivered",
  sending: "status-sent",
  approved: "status-in-production",
  draft: "slate",
  failed: "status-error",
  generating: "slate",
  stalled: "status-error",
  pending: "slate",
};

/**
 * The one place a row states where something is. The detail sheet uses the
 * three-step indicator instead — repeating both on the same surface is how the
 * old cards ended up saying "draft" three times in a row.
 */
export function ChangelogStatusBadge({
  state,
  isDetailed = false,
}: {
  state: ChangelogEntryState;
  /** Spells the state out, for a header with room rather than a table cell. */
  isDetailed?: boolean;
}) {
  const { t } = useTranslation();

  return (
    <Badge variant={STATE_BADGE_VARIANT[state]} dot>
      {t(`admin.changelog.${isDetailed ? "stateDetail" : "state"}.${state}`, {
        defaultValue: state,
      })}
    </Badge>
  );
}
